export default "__VITE_ASSET__Crqn5Ss$__"